"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _noop = _interopRequireDefault(require("lodash/noop"));
var _without = _interopRequireDefault(require("lodash/without"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _withControlledValue = _interopRequireDefault(require("../../hocs/withControlledValue"));
var _TagPickerDialog = _interopRequireDefault(require("../TagPickerDialog"));
var _styles = require("./styles");
var _messages = _interopRequireDefault(require("./messages"));
var _class, _TagPickerComponent; //hocs
//components
//styles
//messages
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TagPickerComponent = (0, _reactIntl.injectIntl)(_class = (0, _withControlledValue["default"])(_class = (_TagPickerComponent = /*#__PURE__*/function (_Component) {
  function TagPickerComponent() {
    var _this;
    _classCallCheck(this, TagPickerComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TagPickerComponent, [].concat(args));
    _defineProperty(_this, "handleDialogChange", function (tagNames) {
      var _this$props = _this.props,
        onChange = _this$props.onChange,
        onDialogClose = _this$props.onDialogClose;
      onDialogClose();
      onChange(tagNames);
    });
    _defineProperty(_this, "handleRemoveTagClick", function (tagName) {
      var _this$props2 = _this.props,
        onChange = _this$props2.onChange,
        onDialogClose = _this$props2.onDialogClose,
        value = _this$props2.value;
      onDialogClose();
      onChange((0, _without["default"])(value, tagName));
    });
    return _this;
  }
  _inherits(TagPickerComponent, _Component);
  return _createClass(TagPickerComponent, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        allTags = _this$props3.allTags,
        intl = _this$props3.intl,
        isDialogOpen = _this$props3.isDialogOpen,
        onDialogClose = _this$props3.onDialogClose,
        onDialogOpen = _this$props3.onDialogOpen,
        value = _this$props3.value;
      var formatMessage = intl.formatMessage;
      return /*#__PURE__*/_react["default"].createElement(_styles.TagPicker, null, value.map(function (tagName) {
        return /*#__PURE__*/_react["default"].createElement(_styles.StyledTag, {
          iconName: "close",
          iconSize: 8,
          key: tagName,
          onClick: function onClick() {
            return _this2.handleRemoveTagClick(tagName);
          },
          tagName: tagName
        });
      }), /*#__PURE__*/_react["default"].createElement(_styles.StyledTag, {
        iconName: "plus",
        onClick: onDialogOpen,
        tagName: formatMessage(_messages["default"].searchPage_addTags)
      }), /*#__PURE__*/_react["default"].createElement(_TagPickerDialog["default"], {
        isOpen: isDialogOpen,
        onChange: this.handleDialogChange,
        onClose: onDialogClose,
        tags: allTags,
        value: value
      }));
    }
  }]);
}(_react.Component), _defineProperty(_TagPickerComponent, "defaultProps", {
  allTags: [],
  onChange: _noop["default"],
  onDialogClose: _noop["default"],
  onDialogOpen: _noop["default"],
  value: []
}), _defineProperty(_TagPickerComponent, "propTypes", {
  allTags: _propTypes["default"].arrayOf(_propTypes["default"].object),
  isDialogOpen: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  onDialogClose: _propTypes["default"].func,
  onDialogOpen: _propTypes["default"].func,
  value: _propTypes["default"].arrayOf(_propTypes["default"].string)
}), _TagPickerComponent)) || _class) || _class;
var _default = exports["default"] = TagPickerComponent;
//# sourceMappingURL=index.js.map